// Landing/GuaranteeCard.tsx

import React from 'react';
import {FC, FR} from 'WideLayout/Layouts';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import {useTheme} from 'Theme/ThemeContext';

interface GuaranteeCardProps {
    size?: 'normal' | 'small';
    cls?: string;
    color?: 'secondary' | 'primary';
}

const GuaranteeCard: React.FC<GuaranteeCardProps> = ({
                                                         size = 'normal',
                                                         cls,
                                                         color = 'secondary',
                                                     }) => {
    const {plt} = useTheme();

    // Выбор текущего цвета на основе пропса `color`
    const currentColor = plt.colors[color];

    return (
        <FC cls={cls} bg={currentColor.lighter}>
            <FR g={'.6rem'}>
                <svg
                    style={{marginTop: 1}}
                    width="24"
                    height="30"
                    viewBox="0 0 24 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                >
                    <path
                        d="M12 0.333496L22.9559 2.76814C23.566 2.90371 24 3.44479 24 4.06972V17.3854C24 20.0602 22.6632 22.558 20.4376 24.0418L12 29.6668L3.5624 24.0418C1.33681 22.558 0 20.0602 0 17.3854V4.06972C0 3.44479 0.43404 2.90371 1.04409 2.76814L12 0.333496ZM17.9365 9.9626L11.3359 16.5614L7.56561 12.791L5.67999 14.6767L11.3368 20.3335L19.8221 11.8482L17.9365 9.9626Z"
                        fill={currentColor.main}
                    />
                </svg>

                <FR fontSize={'1.3rem'}>Гарантия качества</FR>
            </FR>
            {size !== 'small' && (
                <FC>
                    <FR fontSize={'.95rem'} g={1}>
                        <DoneRoundedIcon sx={{color: currentColor.main}} aria-hidden="true"/>
                        <FR>Наличие диплома высшего образования</FR>
                    </FR>
                    <FR fontSize={'.95rem'} g={1}>
                        <DoneRoundedIcon sx={{color: currentColor.main}} aria-hidden="true"/>
                        <FR>Успешно пройденные интервью и кейс</FR>
                    </FR>
                    <FR fontSize={'.95rem'} g={1}>
                        <DoneRoundedIcon sx={{color: currentColor.main}} aria-hidden="true"/>
                        <FR>Регулярная супервизия</FR>
                    </FR>
                </FC>
            )}
        </FC>
    );
};

export default GuaranteeCard;
